import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './components/ui/Toast';
import Layout from './components/layout/Layout';

// Pages
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import EmployeeList from './pages/employees/EmployeeList';
import EmployeeCard from './pages/employees/EmployeeCard';
import ActionLog from './pages/employees/ActionLog';
import StoreList from './pages/stores/StoreList';
import StoreCard from './pages/stores/StoreCard';
import ProductCatalog from './pages/products/ProductCatalog';
import ProductCard from './pages/products/ProductCard';
import ProductCategories from './pages/products/ProductCategories';
import ExpiryMonitoring from './pages/products/ExpiryMonitoring';
import TaskList from './pages/tasks/TaskList';
import CreateTask from './pages/tasks/CreateTask';
import TaskTemplates from './pages/tasks/TaskTemplates';
import OsgChecks from './pages/osg/OsgChecks';
import CriticalExpiry from './pages/osg/CriticalExpiry';
import DisplayReports from './pages/display/DisplayReports';
import PhotoReports from './pages/display/PhotoReports';
import Analytics from './pages/analytics/Analytics';
import Notifications from './pages/notifications/Notifications';
import Settings from './pages/settings/Settings';

function ProtectedApp() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/employees" element={<EmployeeList />} />
        <Route path="/employees/actions" element={<ActionLog />} />
        <Route path="/employees/:id" element={<EmployeeCard />} />
        <Route path="/stores" element={<StoreList />} />
        <Route path="/stores/:id" element={<StoreCard />} />
        <Route path="/products" element={<ProductCatalog />} />
        <Route path="/products/categories" element={<ProductCategories />} />
        <Route path="/products/:id" element={<ProductCard />} />
        <Route path="/products/expiry" element={<ExpiryMonitoring />} />
        <Route path="/tasks" element={<TaskList />} />
        <Route path="/tasks/create" element={<CreateTask />} />
        <Route path="/tasks/templates" element={<TaskTemplates />} />
        <Route path="/osg/checks" element={<OsgChecks />} />
        <Route path="/osg/critical" element={<CriticalExpiry />} />
        <Route path="/display/reports" element={<DisplayReports />} />
        <Route path="/display/photos" element={<PhotoReports />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/analytics/employees" element={<Analytics />} />
        <Route path="/analytics/stores" element={<Analytics />} />
        <Route path="/analytics/categories" element={<Analytics />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/roles" element={<Settings />} />
        <Route path="/settings/audit" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function AuthGuard() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 44, height: 44, borderRadius: '50%',
            border: '3px solid rgba(0, 206, 238, 0.2)',
            borderTopColor: '#00CEEE',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 16px',
          }} />
          <div style={{ color: '#94A3B8', fontSize: 13, fontWeight: 500 }}>Загрузка...</div>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/*" element={<ProtectedApp />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <AuthGuard />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
